import { marked } from 'marked'

marked.setOptions({
  breaks: true,
  gfm: true
})

export function renderMarkdown(text) {
  if (!text) return ''
  const trimmed = String(text).trim()
  if (/^<[a-z][\s\S]*>/i.test(trimmed)) return trimmed
  return marked.parse(trimmed)
}
